import warningIcon from "@assets/images/exclamation.svg";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  makeStyles,
  Typography
} from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        maxWidth: 440,
        width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogTitle-root": {
        padding: "73px 24px 20px 24px",
        textAlign: "center"
      },
      "& .MuiDialogContent-root": {
        padding: "0px 24px 0 24px",
        height: 48,
        textAlign: "center"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px 24px 32px",
        columnGap: 16
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      }
    },
    checkCircleimg: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    title: {
      color: "#333",
      marginRight: "4px",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "26px"
    },
    dialog: {
      display: "flex",
      width: "620px",
      padding: theme.spacing(4),
      flexDirection: "column",
      alignItems: "center",
      gap: "32px",
      borderRadius: "16px",
      background: "var(--Grayscale-White, #FFF)",
      boxShadow: "0px 8px 24px 0px rgba(0, 0, 0, 0.24)"
    },
    titles: {
      color: "#222",
      textAlign: "center",
      fontFamily: "SCG",
      fontSize: "20px",
      fontStyle: "normal",
      lineHeight: "26px",
      fontWeight: 700
    },
    button: {
      color: "white",
      background: "white",
      borderRadius: "4px",
      width: "260px",
      padding: "12px",
      border: "2px solid #FD0045"
    },
    message: {
      justifyContent: "center",
      alignItems: "center",
      fontFamily: "SCG",
      fontSize: "16px",
      fontStyle: "normal",
      fontWeight: 400,
      color: " #222",
      lineHeight: "24px",
      display: "flex",
      whiteSpace: "nowrap"
    },
    firstLine: {
      whiteSpace: "nowrap"
    },
    succcesType: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "5px"
    },
    btnAction: {
      color: "white",
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%) !important",
      borderRadius: "4px",
      width: "260px",
      padding: "12px",
      "&:hover": {
        background:
          "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%) !important"
      }
    }
  }),
  { name: "DialogError" }
);

export interface Props {
  visible: boolean;
  onClose: () => void;
  taxId: number;
  branchId: number;
  onSubmit: () => void;
}

const DialogError = ({
  visible,
  onClose,
  onSubmit,
  taxId,
  branchId
}: Props) => {
  const classes = useStyles();
  const intl = useIntl();
  let firstLine;
  let title;
  if (taxId <= 0 || branchId <= 0) {
    title = "ยังไม่ได้ระบุ Tax Number 3, Tax Number 4";
    firstLine =
      "กรุณาตรวจสอบว่า คุณต้องการระบุ Tax Number 3, Tax Number 4 หรือไม่ ?";
  }
  const secondLine =
    "   กด 'ต้องการ' เพื่อกลับไประบุ หรือกด 'ไม่ต้องการ' เพื่อดำเนินการต่อ ";
  return (
    <Dialog
      open={visible}
      keepMounted
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
      style={{ zIndex: 1301 }}
      data-testid="taxNumber-confirmDialog"
    >
      <Box className={classes.dialog}>
        <div className={classes.checkCircleimg}>
          <img
            src={warningIcon}
            alt="Warning Icon"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
        <div className={classes.succcesType}>
          <Typography className={classes.titles}>
            {intl.formatMessage(
              {
                defaultMessage: "{title}",
                description: "title"
              },
              { title }
            )}
          </Typography>
        </div>
        <div>
          <Typography className={classes.message}>
            {intl.formatMessage(
              {
                defaultMessage: "{firstLine}",
                description: "first line"
              },
              { firstLine }
            )}
          </Typography>
          <Typography className={classes.message}>
            {intl.formatMessage(
              {
                defaultMessage: "{secondLine}",
                description: "second line"
              },
              { secondLine }
            )}
          </Typography>
        </div>

        <DialogActions
          disableSpacing={true}
          style={{ justifyContent: "space-between" }}
        >
          <Button
            id="closeButton"
            data-testid="taxNumber-confirmDialog-closeButton"
            color="primary"
            variant="contained"
            className={classNames(classes.btnAction)}
            fullWidth={true}
            onClick={onClose}
            style={{ marginRight: 30 }}
          >
            {<FormattedMessage defaultMessage={"ต้องการ"} />}
          </Button>
          <Button
            id="submitButton"
            data-testid="taxNumber-confirmDialog-submitButton"
            color="primary"
            variant="outlined"
            className={classNames(classes.button)}
            fullWidth={true}
            onClick={onSubmit}
            style={{ color: "#FD0045", marginLeft: 30 }}
          >
            {<FormattedMessage defaultMessage={"ไม่ต้องการ"} />}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default DialogError;
